export const API_KEY = "openweather-apikey";
